import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[allowOnlyNumber]'
})
export class AllowOnlyNumberDirective {

  @HostListener('input', ['$event'])
  onInput(event: KeyboardEvent): void {
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;

    // Filter out non-alphanumeric characters
    const filteredValue = this.formatPanInput(currentValue.toUpperCase());

    // Update the input value with the filtered value
    if (filteredValue !== currentValue) {
      inputElement.value = filteredValue;
      inputElement.dispatchEvent(new Event('input'));
    }
  }

  private formatPanInput(inputValue: string): string {

      if(inputValue.length > 17){
        const inputValu = inputValue.split('');
        inputValu.pop();
        return inputValu.join(''); 
      }

      const validCharacters = inputValue.replace(/[^0-9]/g, '');
      return (validCharacters ? validCharacters : '');


  }

}
